export default __webpack_public_path__ + "static/media/wheelIconL.0ec386dc.svg";